<template>
  <div :style="styles.base" @click="handleClickEvent()">
    <ceiba-payment
      :payId="currentPaymentConfig.payId"
      :payInfoFlow="currentPaymentConfig.payInfoFlow"
      :sellChannel="sellChannel"
      :payBusiness="configurationData.payBusiness"
      :isUseRoleLimit="configurationData.forceRole"
      :spInfo="spInfo"
      :superCoupons="superCouponsInfo"
      :inviteCode="inviteCode"
      :isBlockOrderFailAlert="!!currentPaymentConfig.payFailMsg"
      :sellScene="configurationData.sellScene"
      @pay-success="handlePaySuccess"
      @pay-close="handlePayClose"
      @reach-limit="handleReachLimit"
      @get-pay-info="handleGetPayInfo"
      @midas-buy="handleMidasBuy"
      @query-unpaid-orders="handleQueryOrders"
      @cancel-order="handleCancelOrder"
      ref="paymentRef"
      :flowRootParam="{quantity}"
    >
    </ceiba-payment>
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <!--订单二次确认弹框-->
    <c-dialog
      v-model="confirmOrder"
      :option="confirmOrderDialogOption"
      @confirm="confirmOrder = false"
      @close="confirmOrder = false"
      v-transfer-dom
    >
      <template slot="body">
        <div >
          <div
            :class="getCss('msg-item')"
            v-for="(option, index) of confirmOrderDialogContent"
            :key="index"
          >
            <span :class="getCss('msg-item-label')"
            >{{ option.label }}:</span>
            <span :class="getCss('msg-item-content')"
                  v-html="confirmOrderOption(option.content)"></span>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div>
          <button
            :style="confirmOrderButtonStyle"
            class="ceiba-dialog-ft-button"
            @click="payOrderViaSecondConfirm()"
          >{{ confirmOrderButtonText }}
          </button>
        </div>
      </template>
    </c-dialog>
    <!--ios支付引导弹框-->
    <c-dialog v-model="isShowIosPaymentGuide" :option="iosPaymentGuideOption"
                   @close="isShowIosPaymentGuide = false"
                   @confirm="isShowIosPaymentGuide = false"
                   v-transfer-dom>
      <template slot="body">
        <div :class="getCss('payment-wrap')">
          <p :class="getCss('tips')"> {{ configurationData.iosPaymentGuideText }}</p>
        </div>
      </template>
      <template slot="footer">
        <div :style="iosPaymentGuideTipStyle">
          <div :style="iosPaymentGuideTipStyle" :class="getCss('tips-action-button')">
            <button
              v-if="isShowIosCopyPaymentGuideTextButton"
              class="ceiba-dialog-ft-button"
              :style="copyButtonStyle"
              @click="copyFunc()"
            >
            </button>
          </div>
        </div>
      </template>
    </c-dialog>

    <!--自定输入购买数量弹窗-->
    <c-dialog v-model="showInputBuyQuantity" :option="inputBuyGoodsNumPopOption"
                   @close="closeInputBuyQuantityPop"
                   @confirm="closeInputBuyQuantityPop"
                   v-transfer-dom>
      <template slot="body">
        <div :class="getCss('pay-num-wrap')">
          <div :class="getCss('goods-img-area')">
            <img
              v-if="currentPaymentConfig.goodsImage"
              :src="currentPaymentConfig.goodsImage" alt="">
          </div>
          <div :class="getCss('input-line')">
            <span :style="inputLabelStyle"
                  :class="getCss('input-label')">{{inputBuyQuantityLabelTitle}}</span>
                  <button
                    @click="add(-1)"
                    :style="inputReduceIconStyle"
                    :class="getCss('input-button')"></button>
                  <input :style="inputTextStyle"
                   :value="quantity"
                   @input="handleInputQuantity"
                   @change="handleInputQuantity"
                   :class="getCss('input')" type="number"/>
                   <button :style="inputAddIconStyle"
                    @click="add(1)"
                    :class="getCss('input-button')"></button>
          </div>
          <div :class="getCss('submit-btn')"
               @click="payOrderViaInputGoodsQuantity"
               :style="submitBugIconStyle">
          </div>
          <div :class="getCss('submit-buy-quantity-error')">
            <span v-if="showInputBuyQuantityLimitError" :style="isInputBuyQuantityLimitErrorTextStyle">
                  {{inputBuyQuantityErrorMsg}}
            </span>
           </div>
        </div>
      </template>
    </c-dialog>

  </div>
</template>
<script>
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
// import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
// import CDialog from '.././../../../ceiba-base-components/src/components/ceiba-dialog';

// ios 不可直接支付的地方  做弹框提示
const iosPaymentInApp = 1; // app内触发ios引导
const iosPaymentInQQ = 2;  // QQ客户端内触发ios引导
const iosPaymentInWx = 3; // wx客户端内触发ios引导
// 安卓 不可直接支付的地方  做拉起app处理
const androidPaymentForBidInQQ = 4;  // 不能在安卓QQ购买
const androidPaymentForBidInWx = 5; // 不能在安卓微信购买

// 1，首购，有没有购买
const paymentModelFirstBugWithDiscount = 1;
// 2，常规 （复购） 优惠券+购买多次
const paymentModelMoreBugWithDiscount = 2;
// 3、没有券  固定价格支付
const paymentModelMoreBugWithFixedPrice = 3;

const iosCopyTextDefaultValueUseInApp = 1; //  复制链接默认值使用在心悦App
const iosCopyTextDefaultValueUseInQQ = 2;  // 复制链接默认值使用在QQ
const iosCopyTextDefaultValueUseInWx = 3; // 复制链接默认值使用在微信

const forbiddenUserPaymentWithCouponRemark = 'noCoupons'; // 禁止支付使用优惠券标志
const couponAvailableUseStatus = 1; // 券可用状态
const couponNotAvailableUseInTimeStatus = 5; // 券不可用状态 未到使用时间

export default {
  name: 'CPublicPayButtonV2',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-pay-button-v2',
      remnantPayTimes: 1, // 剩余支付次数
      availableQuantityTimes: 1, // 剩余总限量，剩余总限量为0，不可支付
      confirmOrder: false, // 是否显示订单二次确认弹框
      isShowIosPaymentGuide: false, // 是否显示显示ios支付引导
      batchId: '', // 当前选中选中的优惠券
      couponList: [], // 获取到优惠券列表
      paymentButtonStatus: 1,
      currentPaymentConfig: {},
      inviteCode: '', // 邀请码
      quantity: 1, // 自定义输入数量
      showInputBuyQuantity: false, // 打开显示输入购买数量
      showInputBuyQuantityLimitError: false, // 自定义数量购买显示错误
    };
  },
  computed: {
    sellChannel() {
      const { sellChannel = '' } = this.configurationData;
      if (this.$isInEditor) return  sellChannel;
      let { specifiedSellChannel = [] } = this.configurationData;
      console.log('parse before channel 区分销售渠道=  ', specifiedSellChannel);
      if (!(specifiedSellChannel instanceof Array)) {
        specifiedSellChannel = [];
      }
      if (specifiedSellChannel.length === 0) {
        console.warn('call getSellChannel and specifiedSellChannel is empty and access default sellChannel = ', sellChannel);
        return  sellChannel;
      }
      try {
        specifiedSellChannel = specifiedSellChannel.map((item) => {
          if (typeof item === 'string' && item.length > 0) {
            return JSON.parse(item);
          }
          return item;
        });
      } catch (e) {
        console.error(' parse specifiedSellChannel  has error and access default sellChannel = ', sellChannel);
        return  sellChannel;
      }
      const hitChannel = typeof common.tool.getRuleValue === 'function'
        ? common.tool.getRuleValue(this, specifiedSellChannel) : '';
      console.log('call getSellChannel and return hitChannel  2 = ', hitChannel);
      if  (typeof  hitChannel !== 'string' || hitChannel.length ===  0) {
        console.warn('call getSellChannel and not match and access default sellChannel = ', sellChannel);
        return sellChannel;
      }
      return hitChannel;
    },
    inputLabelStyle() {
      const { fontFamily, textColor, textFontSize } = this.inputBuyGoodsStyleConfig;
      return {
        fontFamily,
        color: textColor,
        fontSize: textFontSize,
      };
    },
    inputTextStyle() {
      const { fontFamily, inputBgColor, inputNumColor, inputNumFontSize } = this.inputBuyGoodsStyleConfig;
      return {
        fontFamily,
        backgroundColor: inputBgColor,
        color: inputNumColor,
        fontSize: inputNumFontSize,
      };
    },
    inputAddIconStyle() {
      const { addNumIcon } = this.inputBuyGoodsStyleConfig;
      return {
        backgroundImage: `url(${addNumIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
      };
    },
    inputReduceIconStyle() {
      const { reduceIcon } = this.inputBuyGoodsStyleConfig;
      return {
        backgroundImage: `url(${reduceIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
      };
    },
    submitBugIconStyle() {
      const { submitBugIconWidth, submitBugIconHeight, submitBugIcon } = this.inputBuyGoodsStyleConfig;
      return {
        width: submitBugIconWidth,
        height: submitBugIconHeight,
        backgroundImage: `url(${submitBugIcon})`,
      };
    },
    /**
     * 输入自定义模式单次购买超过限购的文案，并且能替换显示的限制数量
     * @returns {string}
     */
    inputBuyQuantityErrorMsg() {
      const { inputBuyQuantityErrorText = '' } = this.configurationData;
      if  (!inputBuyQuantityErrorText) {
        return '';
      }
      return inputBuyQuantityErrorText.replace('{{num}}', this.quantity);
    },
    /**
     * 单次购买超过限购的文案的内联样式
     * @returns {{fontFamily: *, color: string, fontSize: string}}
     */
    isInputBuyQuantityLimitErrorTextStyle() {
      const { textBuyLimitErrorColor = '#da123f', textBuyLimitFontSize = '0.24rem', fontFamily } = this.inputBuyGoodsStyleConfig;
      return {
        color: textBuyLimitErrorColor,
        fontSize: textBuyLimitFontSize,
        fontFamily,
      };
    },
    inputBuyQuantityLabelTitle() {
      const { inputBuyQuantityLabelTitle = '购买数量' } = this.configurationData;
      return inputBuyQuantityLabelTitle;
    },
    inputBuyGoodsStyleConfig() {
      return this.styles.inputBuyGoodsNumPopConfig ?? {};
    },
    // 输入购买数量
    inputBuyGoodsNumPopOption() {
      const {
        bgImage = '', popWidth = '676px',
        popHeight = '548px',
      } = this.inputBuyGoodsStyleConfig;
      return Object.assign({}, this.dialogConfig, {
        footer: false,
        close: true,
        header: '购买道具',
        cancel: false,
        confirm: false,
        confirmStyle: {},
        width: popWidth,
        height: popHeight,
        // closeLocation: 'bottom-center',
        dialogStyle:
          {
            backgroundImage: bgImage ? `url(${bgImage})` : this.dialogConfig?.dialogStyle?.backgroundImage,
          }
        ,
      })
      ;
    },
    // 是否自定义输入购买数量
    isInputBuyQuantity() {
      const { isInputBuyQuantity = false } = this.configurationData;
      return isInputBuyQuantity;
    },
    // 点击支付按钮是否拉起app
    checkIsCallApp() {
      const { androidPaymentForBidDeviceList = [], forceApp } = this.configurationData;
      console.log('checkIsCallApp androidPaymentForBidDeviceList =', androidPaymentForBidDeviceList, 'forceApp =', forceApp);
      if (!!forceApp === true) {
        console.warn('checkIsCallApp 所有的支付 强制跳转app');
        return true;
      }
      console.warn('checkIsCallApp common.platform =', common.platform);

      if (common.platform.isAndroid) {
        if (androidPaymentForBidDeviceList.length === 0) {
          console.warn('checkIsCallApp 安卓没有设置禁止支付设备 不跳转app');
          return false; // 没有设置拉起app
        }

        if (androidPaymentForBidDeviceList.indexOf(androidPaymentForBidInQQ) > -1 && common.platform.isQQ) {
          console.warn('checkIsCallApp 端外安卓QQ设备禁止支付  跳转心悦app');
          return true; // 设置拉起app
        }
        if (androidPaymentForBidDeviceList.indexOf(androidPaymentForBidInWx) > -1 && common.platform.isWX) {
          console.warn('checkIsCallApp 端外安卓微信设备禁止支付  跳转心悦app');
          return true; // 设置拉起app
        }
      }
      // ios拉起app代码先注释
      // if (common.platform.isIos) {
      //   const isNeedIosPaymentGuide = this.handleIosPaymentGuide();
      //   console.warn('checkIsCallApp ios 设备判定支付是否需要引导，结果 = ', isNeedIosPaymentGuide === false);
      //   return isNeedIosPaymentGuide === false;
      // }
      console.warn('checkIsCallApp 不匹配任何情况 不跳转app');
      return false;
    },
    confirmOrderDialogContent() {
      const { paymentButtonStatus } = this;
      return this.configurationData[`confirmOrderDialogContentStatus_${paymentButtonStatus}`] || [];
    },
    // 1，首购，有没有购买
    isPaymentModelFirstBugWithDiscount() {
      const { paymentMode = [1, 2, 3] } = this.configurationData;
      return paymentMode.indexOf(paymentModelFirstBugWithDiscount) > -1
        && this.paymentButtonStatus === paymentModelFirstBugWithDiscount;
    },
    // 2，常规 （复购） 优惠券+购买多次
    isPaymentModelMoreBugWithDiscount() {
      const { paymentMode = [1, 2, 3] } = this.configurationData;
      return paymentMode.indexOf(paymentModelMoreBugWithDiscount) > -1
        && this.paymentButtonStatus === paymentModelMoreBugWithDiscount;
    },
    // 3、没有券  固定价格支付
    isPaymentModelMoreBugWithFixedPrice() {
      const { paymentMode = [1, 2, 3] } = this.configurationData;
      return paymentMode.indexOf(paymentModelMoreBugWithFixedPrice) > -1
        && this.paymentButtonStatus === paymentModelMoreBugWithFixedPrice;
      ;
    },
    isMobile() {
      return common.platform.isIos || common.platform.isAndroid;
    },
    // 支付按钮的状态
    // 按钮样式 payBackgroundImage 支付icon
    // 按钮样式 payDoneBackgroundImage 已达上限按钮
    computedStyle() {
      const paymentConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      const { payBackgroundImage, payDoneBackgroundImage, notAvailableQuantityBackgroundImage } = paymentConfig;
      let backgroundImage = payBackgroundImage;
      if (this.availableQuantityTimes <= 0) { // 没有总限
        backgroundImage = notAvailableQuantityBackgroundImage;
      } else {
        if (this.remnantPayTimes <= 0) { // 没有个限
          backgroundImage = payDoneBackgroundImage;
        }
      }
      return {
        cursor: 'pointer',
        position: 'static',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${backgroundImage})`,
      };
    },
    // 二次确认弹框
    confirmOrderDialogOption() {
      return Object.assign({}, this.dialogConfig, {
        header: this.configurationData.confirmOrderDialogTitle || '订单确认',
        footer: true,
        height: this.deviceMode === 'pc' ? '660px' : '6.6rem',
        width: this.deviceMode === 'pc' ? '820px' : '7.2rem',
        dialogStyle: Object.assign({ color: '#000000' }, this.dialogConfig?.dialogStyle || {}),
      });
    },
    // 二次确认弹框下单样式
    confirmOrderButtonStyle() {
      if (this.dialogConfig?.confirmStyle?.backgroundImage) {
        return {
          width: '2.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: this.dialogConfig?.confirmStyle?.backgroundImage,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          // backgroundSize:'100% 100%',
          margin: '0 0',
        };
      }
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    confirmOrderButtonText() {
      return this.dialogConfig?.confirmStyle?.backgroundImage ? '' : '确认';
    },
    isApp() {
      return this.$ast.isAPP();
    },
    //  ios 引导
    iosPaymentGuideOption() {
      return Object.assign({}, this.dialogConfig, {
        footer: true,
        close: true,
        header: '温馨提示',
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    iosPaymentGuideTipStyle() {
      return {
        width: this.dialogConfig.width,
      };
    },
    // ios 复制按钮
    copyButtonStyle() {
      const { copyButtonIcon = '' } = this.configurationData;
      if (copyButtonIcon) {
        return {
          width: '2.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: `url(${copyButtonIcon})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          // backgroundSize:'100% 100%',
          margin: '0 auto',
        };
      }
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        content: '复制链接',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    // 是否显示ios复制引导内容按钮
    isShowIosCopyPaymentGuideTextButton() {
      const { isShowIosCopyPaymentGuideTextButton = false } = this.configurationData;
      return !!isShowIosCopyPaymentGuideTextButton;
    },
    defaultKeyValue() {
      const { defaultKeyValue = '' } = this.configurationData;
      console.log('this.isDefaultKeyValueUseDevice =', this.isDefaultKeyValueUseDevice);
      if (!defaultKeyValue || this.isDefaultKeyValueUseDevice === false) {
        return {};
      }
      if (typeof defaultKeyValue === 'string' && defaultKeyValue.length > 0) {
        const tempArray = defaultKeyValue.split('&').map(item => item.split('='));
        return Object.fromEntries(tempArray);
      }
      return {};
    },
    // 是否需要判定默认值使用的客户端
    isDefaultKeyValueUseDevice() {
      const { defaultKeyValueUseDeviceType = [] } = this.configurationData;
      //  需要判定默认值使用的客户端
      if (defaultKeyValueUseDeviceType.indexOf(iosCopyTextDefaultValueUseInApp) === -1 && this.isApp) {
        return false;
      }
      if (defaultKeyValueUseDeviceType.indexOf(iosCopyTextDefaultValueUseInQQ) === -1 && common.platform.isQQ) {
        return false;
      }
      if (defaultKeyValueUseDeviceType.indexOf(iosCopyTextDefaultValueUseInWx) === -1 && common.platform.isWX) {
        return false;
      }
      return true;
    },
    // ios复制引导内容  如果不填写会自动获取当前链接
    copyIosPaymentGuideText() {
      const { copyIosPaymentGuideText = '' } = this.configurationData;
      let text = copyIosPaymentGuideText || window.location.href;
      console.log('before copyIosPaymentGuideText = ', text);
      const that = this;
      if (typeof copyIosPaymentGuideText === 'string' && copyIosPaymentGuideText.length > 0) {
        text = copyIosPaymentGuideText.replaceAll(
          /{{\s?([A-Za-z0-9_\\.]+)\s?}}/g,
          (_r, match) => common.tool.getQueryparams(match, window.location.href)
            || that.defaultKeyValue[match] || '',
        );
      }
      console.log('after  copyIosPaymentGuideText = ', text);
      return text;
    },
    // 下单支付时可用优惠券的列表
    spInfo() {
      const spInfoText = this.superCouponsInfo === forbiddenUserPaymentWithCouponRemark ? '' : this.superCouponsInfo;
      console.log('computer 可用优惠券列表 spInfo res  =', spInfoText);
      return spInfoText;
    },
    // 支付是否使用优惠券
    // noCoupons 表示禁止支付选用优惠券
    // “${codeId},${batchId}”  //  这个是选中一张默认优惠券
    superCouponsInfo() {
      if (!this.batchId) {
        console.log('computer superCouponsInfo res = empty', forbiddenUserPaymentWithCouponRemark);
        return forbiddenUserPaymentWithCouponRemark;
      }
      if (this.couponList.length === 0) return forbiddenUserPaymentWithCouponRemark;
      const { batchId } = this;
      const item = this.couponList.find(item => item.batch_id === batchId);
      const res = item ? `${item.code_id},${item.batch_id}` : forbiddenUserPaymentWithCouponRemark;
      console.log('computer superCouponsInfo res =', res);
      return res;
    },
  },
  watch: {
    //  更改支付模式
    'configurationData.defaultPaymentMode': {
      handler(value) {
        if (value && parseInt(value, 10) > 0) {
          this.paymentButtonStatus = parseInt(value, 10);
        }
      },
      immediate: true,
    },
    paymentButtonStatus: {
      handler(value) {
        if (value && parseInt(value, 10) > 0) {
          this.currentPaymentConfig = this.getPaymentConfigByStatus(value);
        }
        console.log('on watch  this.currentPaymentConfig and status value =', value);
        console.log('on watch  this.currentPaymentConfig =', this.currentPaymentConfig);
      },
      immediate: true,
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    closeInputBuyQuantityPop() {
      this.showInputBuyQuantityLimitError = false;
      this.showInputBuyQuantity = false;
    },
    /**
     * 购买数量+1,并且触发输入购买超过单次购买限量的状态
     * @param step
     */
    add(step) {
      const { maxGoodsNum = 0 } = this.configurationData;
      const num = this.quantity + step;
      if (num > maxGoodsNum) {
        this.quantity = maxGoodsNum;
        this.showInputBuyQuantityLimitError = true;
      } else if (num <= 0) {
        this.quantity = 1;
        this.showInputBuyQuantityLimitError = false;
      } else {
        this.quantity = num;
      }
      console.log('this.quantity = ', this.quantity);
    },
    handleInputQuantity(e) {
      const num = parseInt(e.target.value, 10);
      const { maxGoodsNum = 0 } = this.configurationData;
      console.log('handleInputPrice num =', num, 'maxGoodsNum =', maxGoodsNum);
      if (num > maxGoodsNum) {
        this.quantity = maxGoodsNum;
        e.target.value = maxGoodsNum;
        this.showInputBuyQuantityLimitError = true;
      } else if (num <= 0) {
        this.quantity = 1;
        e.target.value = 1;
        this.showInputBuyQuantityLimitError = false;
      } else {
        this.quantity = num;
        e.target.value = num;
        this.showInputBuyQuantityLimitError = false;
      }
      console.log('this.quantity = ', this.quantity);
    },
    async initialize() {
      if (this.$isInEditor) return;
      common.tool.loadScript('midas-js', 'https://midas.gtimg.cn/h5pay/js/api/midas.js', () => {
      });
      this.inviteCode = common.tool.getQueryparams('inviteCode') || '';
      console.log('是否拉起app 判定结果 this.checkIsCallApp=', this.checkIsCallApp);
      this.$refs.button.setClickHandler(this.payOrder, {
        forceLogin: true,
        forceApp: this.checkIsCallApp,
        forceRole: this.configurationData.forceRole,
      });
      const { defaultPaymentMode = paymentModelFirstBugWithDiscount } = this.configurationData;
      this.paymentButtonStatus = defaultPaymentMode;
      if (this.configurationData.forceRole) {
        this.$onRoleReady(async () => {
          //  查询当前状态
          await this.checkCurrentPaymentButtonMode();
          // 查询剩余限量
          await this.queryAvailableQuantity();
          //  查询是否购买
          await this.queryRemnantPayTimes();
        });
      } else {
        this.$onLogined(async () => {
          //  查询当前状态
          await this.checkCurrentPaymentButtonMode();
          // 查询剩余限量
          await this.queryAvailableQuantity();
          //  查询是否购买
          await this.queryRemnantPayTimes();
        });
      }
      ;
    },
    // 确定支付当前状态的流程
    async checkCurrentPaymentButtonMode() {
      const { paymentMode = [], checkPaymentModeFlowId = 0 } = this.configurationData;
      console.log('access checkCurrentPaymentButtonMode paymentMode= ', paymentMode, checkPaymentModeFlowId);
      //  只有一种支付状态 不需要请求
      if (paymentMode.length <= 1 || checkPaymentModeFlowId === 0) {
        return false;
      }
      const params = {
        flowId: checkPaymentModeFlowId,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('checkCurrentPaymentButtonMode response= ', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        console.log('checkCurrentPaymentButtonMode error ', msg);
        return false;
      }
      const { ret: resRet, msg: resMsg } = data;
      let { status } = data;
      if (resRet !== 0) {
        console.log('checkCurrentPaymentButtonMode error ', resMsg);
        return false;
      }
      status = parseInt(status, 10);
      // 如果不需要展示这种支付状态 则维持原来的这种状态
      paymentMode.sort((a, b) => a - b);
      if (paymentMode.indexOf(status) === -1) {
        this.paymentButtonStatus = paymentMode[paymentMode.length - 1];
        console.warn('配置没有额外的支付模式', paymentMode, this.paymentButtonStatus);
        return;
      }
      this.paymentButtonStatus = status;
      console.log('已经成功设置对应的支付模式  = ', this.paymentButtonStatus);
    },
    // 获取对应支付状态配置信息
    getPaymentConfigByStatus(status) {
      const { paymentInfoConfigList = [] } = this.configurationData;
      const res = paymentInfoConfigList.find(item => parseInt(item.status, 10) === status);
      if (!res) {
        console.error('支付状态信息没有配置 status = ', status);
      }
      return res;
    },
    async beforePayOrderCheck() {
      const paymentConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      console.log('paymentConfig = is not found status', this.paymentButtonStatus, paymentConfig);
      if (!paymentConfig) {
        console.warn('paymentConfig = is not found status', this.paymentButtonStatus);
        return false;
      }
      ;
      const {
        notAvailableQuantityMsg,
        notRemnantPayTimesMsg,
      } = paymentConfig;

      // 先查询是否还有上限
      await this.queryAvailableQuantity(); // 查询剩余总限
      if (this.availableQuantityTimes <= 0) {
        if (!!notAvailableQuantityMsg) this.$alert({ msg: notAvailableQuantityMsg || '已售罄' });
        return false;
      }
      await this.queryRemnantPayTimes(); // 查询剩余支付次数
      if (this.remnantPayTimes <= 0) {
        if (!!notRemnantPayTimesMsg) this.$alert({ msg: notRemnantPayTimesMsg || '已购买' });
        return false;
      }
      // 如果固定价格 怎不需要券
      if (!this.isPaymentModelMoreBugWithFixedPrice) {
        await this.queryCouponList(); // 查询优惠券
      }

      return true;
    },
    handleGoodsNumInput() {
      if (this.isInputBuyQuantity) {
        this.quantity = 1;
        this.showInputBuyQuantity = true;
        return true;
      }
      return false;
    },
    // 下单
    async payOrder() {
      // ios|心悦app|带dora开头traceId的活动且打开风控闸门，会强制打开引导
      if (this.riskControlFlag === true) {
        this.isShowIosPaymentGuide = true;
        return;
      }
      // ios 是否有配置端外引导
      const isNeedIosPaymentGuide = this.handleIosPaymentGuide();
      console.log('payOrder isNeedIosPaymentGuide', isNeedIosPaymentGuide);
      if (isNeedIosPaymentGuide === false) return false;

      // 下单前检验，查询是否已经达到限量
      const beforePayOrderCheck = await this.beforePayOrderCheck();
      if (!beforePayOrderCheck) {
        console.warn('beforePayOrderCheck before Check not ok ');
        return;
      }

      // 是否有自定义输入模式
      if (this.handleGoodsNumInput() === true) {
        console.log('开始自定义输入购买数量模式');
        return false;
      }
      const { isConfirmOrder } = this.configurationData;
      if (isConfirmOrder) {
        this.confirmOrder = true;
        return;
      }
      await this.toOrder();
    },
    /**
     * 关闭订单确认弹窗
     */
    closePayOrderViaSecondConfirmPop() {
      this.confirmOrder = false;
    },
    // 通过订单确认下单
    async payOrderViaSecondConfirm() {
      const beforePayOrderCheck = await this.beforePayOrderCheck();
      if (!beforePayOrderCheck) {
        console.warn('beforePayOrderCheck before Check not ok ');
        return;
      }
      this.closePayOrderViaSecondConfirmPop();
      await this.toOrder();
    },
    // 通过订单确认下单
    async payOrderViaInputGoodsQuantity() {
      const { maxGoodsNum = 100 } = this.configurationData;
      if (this.quantity <= 0) {
        this.$alert({ msg: '购买商品数量不能为零' });
        return false;
      }
      if (this.quantity > maxGoodsNum) {
        this.$alert({ msg: '单次购买数量超过上限' });
        return false;
      }
      const { isConfirmOrder } = this.configurationData;
      if (isConfirmOrder) {
        this.closeInputBuyQuantityPop();
        this.confirmOrder = true;
        return;
      }
      const beforePayOrderCheck = await this.beforePayOrderCheck();
      if (!beforePayOrderCheck) {
        console.warn('beforePayOrderCheck before Check not ok ');
        return;
      }
      this.closeInputBuyQuantityPop();
      await this.toOrder();
    },
    // 支付下单 调用米大师 支付
    async toOrder() {
      if (!this.isLogin) return;
      if (this.remnantPayTimes <= 0) return;
      try {
        await this.$refs.paymentRef.buy();
      } catch (e) {
        console.error('payOrder fail, err=', e);
      }
    },
    // 支付限量
    async handleReachLimit() {
      console.log('====支付限量 ====');
    },
    // 支付失败
    async handlePayClose() {
      console.log('====支付失败 ====');
    },
    // 支付成功回调
    async handlePaySuccess(midasInfo) {
      console.log('handlePaySuccess midasInfo', midasInfo);
      const paymentConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      const { paySuccessFlowId, paySuccessMsg } = paymentConfig;

      await this.refreshQua(); // 刷新礼包
      await this.queryAvailableQuantity();// 查询剩余总限量
      await this.queryRemnantPayTimes(); // 重新查询支付次数
      await this.checkCurrentPaymentButtonMode(); // 重新查询支付模式
      // 支付成功自定义提示
      if (paySuccessMsg) {
        const partitionName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
        const roleName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
        this.$alert({ msg: paySuccessMsg.replace('{{partition}}', partitionName).replace('{{role}}', roleName) });
      }
      if (paySuccessFlowId > 0) {
        await this.paySuccessCallback();
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_callback',
        eventData: {
          pay_id: midasInfo.pay_id,
          order_id: midasInfo.order_id,
          status: '1',
        },
      });
      // 支付成功
      this.refreshContainerStatus();
      this.paySuccessSyncBindBox(midasInfo.order_id);
    },
    //  存在多个预约地方的时候  同步
    refreshContainerStatus() {
      this.$eventBus.$emit('ceiba:custom:events:refresh:container:status', null);
    },
    // 支付成功同步给夺宝组件
    paySuccessSyncBindBox(orderId) {
      const { isBindBoxPay = false } = this.configurationData;
      if (isBindBoxPay) {
        this.$eventBus.$emit('ceiba:tgclubSeizeTreasure:events:dealID:result', { dealID: orderId });
      }
    },
    // 执行下单逻辑
    handleGetPayInfo({ payId, response }) {
      console.log('handleGetPayInfo params', { payId, response });
      const paymentConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      const { payFailMsg } = paymentConfig;
      if (payFailMsg) {
        const partitionName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
        const roleName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
        this.$alert({ msg: payFailMsg.replace('{{partition}}', partitionName).replace('{{role}}', roleName) });
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_makeorder',
        eventData: {
          pay_id: payId,
          status: response.ret === 0 && response.data.ret === 0 ? '1' : '0',
        },
      });
    },
    // 查询未支付的订单
    handleQueryOrders({ response }) {
      console.log('handleQueryOrders params', { response });
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_queryorders',
        eventData: {
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 取消订单
    handleCancelOrder({ orderId, response }) {
      console.log('handleCancelOrder params', { orderId, response });
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_cancelorder',
        eventData: {
          order_id: orderId,
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 米大师支付 (用户拉去支付)
    handleMidasBuy(midasInfo) {
      console.log('handleMidasBuy midasInfo', midasInfo);
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay',
        eventData: {
          pay_id: midasInfo.pay_id,
          order_id: midasInfo.order_id,
          amount: midasInfo.amount,
        },
      });
    },
    // 成功回调流程
    async paySuccessCallback() {
      const { paySuccessFlowId } = this.configurationData;
      if (paySuccessFlowId <= 0) return;
      const response = await this.flowRequest({
        flowId: paySuccessFlowId,
      });
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet === 0) {
        // await this.queryRemnantPayTimes();
      } else {
        return this.$alert({ msg: resMsg || '支付失败' });
      }
    },
    // 查询剩余支付次数|个限量  没有次数就置灰 条件机输出
    async queryRemnantPayTimes() {
      const paymetConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      const { queryRemnantPayTimesFlowId = 0 } = paymetConfig;
      if (queryRemnantPayTimesFlowId <= 0) return;
      const params = {
        flowId: queryRemnantPayTimesFlowId,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('查询剩余支付次数 queryRemnantPayTimes queryRemnantPayTimesFlowId = ', queryRemnantPayTimesFlowId);
      console.log('查询剩余支付次数 queryRemnantPayTimes response ', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { value = 0, ret: resRet } = data;
      if (resRet === 0) {
        this.remnantPayTimes = value;
      }
    },
    // 查询剩余总限量  没有次数就置灰 条件机输出
    async queryAvailableQuantity() {
      const paymetConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      const { queryAvailableQuantityFlowId = 0 } = paymetConfig;
      if (!queryAvailableQuantityFlowId || queryAvailableQuantityFlowId <= 0) return;
      const params = {
        flowId: queryAvailableQuantityFlowId,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('查询剩余总限量 queryAvailableQuantity queryAvailableQuantityFlowId = ', queryAvailableQuantityFlowId);
      console.log('查询剩余总限量 queryAvailableQuantity response ', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { value = 0, ret: resRet } = data;
      if (resRet === 0) {
        this.availableQuantityTimes = value;
      }
    },
    // 订单确认弹框-确认项
    confirmOrderOption(option) {
      const uinTypeName = common.platform.isWX ? '【微信账户】' : '【QQ账户】';
      switch (option) {
        case '{{role}}':
          return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
          break;
        case '{{partition}}':
          return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
          break;
        case '{{uin}}':
          return this.isLogin ? `<span class="csu-public-pay-button-msg-item-nick-name">${this.userInfo.nickName}</span>
            ${uinTypeName}` : `${uinTypeName}`;
          break;
        default:
          return option;
      }
    },
    copyFunc() {
      if (typeof this.copyIosPaymentGuideText === 'string' && this.copyIosPaymentGuideText.length > 0) {
        const textarea = document.createElement('textarea');
        document.body.appendChild(textarea);
        textarea.style.position = 'fixed';
        textarea.style.clip = 'rect(0 0 0 0)';
        textarea.style.top = '10px';
        textarea.value = this.copyIosPaymentGuideText;
        textarea.select();
        document.execCommand('copy', true);
        document.body.removeChild(textarea);
        this.isShowIosPaymentGuide = false;
        this.$toast('复制成功');
      }
    },
    handleIosPaymentGuide() {
      console.log('access  handleIosPaymentGuide', common.platform.isIos);
      if (!common.platform.isIos) {
        console.warn('access  handleIosPaymentGuide 当前不是ios 设备 ');
        return true;
      }
      const {
        iosPaymentGuideText,
        iosPaymentGuideTriggerPlace = [iosPaymentInApp, iosPaymentInQQ, iosPaymentInWx],
      } = this.configurationData;
      // 没有限制
      if (!iosPaymentGuideText) {
        console.warn('access handleIosPaymentGuide   没有设置 iosPaymentGuideText 不引导', iosPaymentGuideText);
        return true;
      }
      // 没有限制
      if (iosPaymentGuideTriggerPlace.length === 0 || !iosPaymentGuideTriggerPlace) {
        console.warn('access handleIosPaymentGuide没有设置引导设备不引导', iosPaymentGuideTriggerPlace);
        return true;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInApp) > -1 && this.isApp) {
        this.isShowIosPaymentGuide = true;
        console.warn('access handleIosPaymentGuide ios 端内 需要引导支付，不能直接支付 ');
        return false;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInQQ) > -1 && common.platform.isQQ) {
        console.warn('access handleIosPaymentGuide ios 端外QQ客户端 需要引导支付，不能直接支付 ');

        this.isShowIosPaymentGuide = true;
        return false;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInWx) > -1 && common.platform.isWX) {
        console.warn('access handleIosPaymentGuide ios 端外微信客户端 需要引导支付，不能直接支付 ');
        this.isShowIosPaymentGuide = true;
        return false;
      }
      return true;
    },
    // 查询优惠券列表
    async queryCouponList() {
      const paymentConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      const { queryCouponListFlow, coupon } = paymentConfig;

      if (!coupon) return;
      const couponList = coupon.split(',').filter(item => !!item);
      if (!queryCouponListFlow || queryCouponListFlow <= 0) return;
      const params = {
        flowId: queryCouponListFlow,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('queryCouponList response:', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      let couponFilterList = [];
      const { data: dataRes, ret: resRet } = data;
      if (resRet === 0 && dataRes && dataRes.length > 0) {
        for (const item of dataRes) {
          if (!this.checkCouponIsStart(item)) continue;
          if (couponList.indexOf(item.batch_id) > -1) {
            couponFilterList.push(item);
          }
        }
      }
      console.log(' queryCouponList couponList filter   in couponFilterList= ', couponFilterList);
      couponFilterList = this.sortCouponList(couponFilterList);
      console.log(' queryCouponList couponList sort  in couponFilterList= ', couponFilterList);
      couponFilterList = this.filterMaxAmtCoupon(couponFilterList);
      console.log(' queryCouponList couponList maxAmtCoupon  in couponFilterList= ', couponFilterList);
      this.couponList = couponFilterList;
      this.batchId = this.couponList.length > 0 ? this.couponList[0]?.batch_id : '';
      console.log(' queryCouponList this.batchId = ', this.batchId);
      console.log('queryCouponList final couponList', this.couponList);
    },
    // 优惠券排序
    sortCouponList(couponFilterList) {
      if (couponFilterList.length <= 1) {
        return couponFilterList;
      }
      couponFilterList.sort((a, b) => {
        if (a.amt !== b.amt) {
          return b.amt - a.amt;
        }
        return a.start_time - b.start_time;
      });
      return couponFilterList;
    },
    // 测试优惠券是否可以使用
    // status  = 1  && sub_status === undefined   可使用
    // sub_status !== undefined && sub_status === 5  &&   status  = 1  不可用
    checkCouponIsStart(couponItem) {
      const { status = 1, sub_status: subStatus } = couponItem;
      console.log('checkCouponIsStart status = ', status, 'sub_status = ', subStatus);
      if (status === couponAvailableUseStatus && typeof subStatus === 'undefined') {
        console.log('checkCouponIsStart res = ', '优惠券可用', couponItem);
        return true;
      }
      if (status === couponAvailableUseStatus && subStatus === couponNotAvailableUseInTimeStatus) {
        console.log('checkCouponIsStart res = ', '优惠券不可用', couponItem);
        return false;
      }
      console.log('checkCouponIsStart res =  ', '不匹配任何状态', couponItem);
      return false;
    },
    // 根据价格筛选最大面额的优惠券
    filterMaxAmtCoupon(couponFilterList) {
      const { orderPrice = 0 } = this.configurationData;
      if (orderPrice <= 0) return couponFilterList;
      let couponList = [];
      const needCoupon = [];
      couponList =  couponFilterList.filter(item => item.least_price <= orderPrice);
      couponList = this.sortCouponList(couponList);
      needCoupon.push(couponList[0]);
      return needCoupon;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
